import { AppHeader } from '@web_opxp/components';
import { AuthSelectors, LanguageSelectors, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Action, Dispatch } from 'redux';
import { AppSelectors } from '../../app';
import ENV from '../../base/env';
import { getInternalUrl } from '../../base/historyService';
import { BridgeSelectors } from '../../bridge';
import { DashboardRoute } from '../../dashboard/Dashboard';
import { MigrationRoute } from '../../migration';
import { IState } from '../../store/state';
import { getMenu } from './menu';
import getUserMenu from './userMenuItems';

export interface IHeaderWrapperProps {
  loading: boolean;
  premium: boolean;
  token?: string;
  bridgeActive: boolean;
  // user name/email
  alias?: string;
  // user picture
  picture?: string;
  // user is authorized
  authorized: boolean;
  // unread status: messages
  regular: number;
  // unread status: friendship requests
  friendship: number;
  // user menu item click handler
  onUserMenuAction: (actionType: string) => void;
}

export const HeaderWrapperFC: React.FC<IHeaderWrapperProps> = ({
  loading,
  premium,
  token,
  bridgeActive,
  alias,
  picture,
  authorized,
  regular,
  friendship,
  onUserMenuAction,
}) => {
  const { t, language } = useTranslation();
  const { pathname } = useLocation();
  if (loading || !token || !language) {
    return null;
  }
  const actionHandler = (action: string) => onUserMenuAction(action);
  const menuLabel = authorized ? alias : t('common:Header.Menu.Login');
  const userMenu = getUserMenu(actionHandler, language, token, regular, friendship);
  const navItems = getMenu(premium, language, token, menuLabel, userMenu, regular + friendship, picture ?? 'default');
  const isMigration = pathname === MigrationRoute;
  return (
    <AppHeader
      logoLabel={t('common:Header.Logo') ?? ''}
      logoLink={getInternalUrl(DashboardRoute)}
      logoSrc={`${ENV.AssetsBaseUrl}/logo.svg`}
      menuItems={navItems}
      showMenu={!isMigration && !bridgeActive}
    />
  );
};

export const mapStateToProps = (state: IState) => {
  const premium = AuthSelectors.isPremium(state);
  const token = AuthSelectors.getToken(state);
  const appLoading = AppSelectors.isAppLoading(state);
  const localeLoading = LanguageSelectors.isLoading(state);
  const loading = appLoading || localeLoading;
  const bridgeActive = BridgeSelectors.isBridgeActive(state);
  const alias = AuthSelectors.getUserEmail(state);
  const picture = AuthSelectors.getUserPicture(state);
  const authorized = AuthSelectors.isAuthorized(state);
  const regular = AuthSelectors.getUnreadMessages(state);
  const friendship = AuthSelectors.getFriendRequests(state);
  return {
    loading,
    premium,
    token,
    bridgeActive,
    alias,
    picture,
    authorized,
    regular,
    friendship,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onUserMenuAction: (actionType: string) => dispatch({ type: actionType } as Action),
  };
};

const HeaderWrapper = connect(mapStateToProps, mapDispatchToProps)(HeaderWrapperFC);
export default HeaderWrapper;
